import React, { useState, useRef, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import PoweredBy from './PoweredBy';
import './Layout.css';

const Layout = ({ children, title }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const headerRef = useRef(null);
  const layoutRef = useRef(null);

  const handleMenuToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const measureHeaderHeight = () => {
      if (headerRef.current && layoutRef.current) {
        const headerHeight = headerRef.current.offsetHeight;
        layoutRef.current.style.setProperty('--header-height', `${headerHeight}px`);
      }
    };

    requestAnimationFrame(() => {
      measureHeaderHeight();
    });

    const handleResize = () => {
      requestAnimationFrame(() => {
        measureHeaderHeight();
      });
    };

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        measureHeaderHeight();
      });
    });

    if (headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={layoutRef} className="layout">
      <Header headerRef={headerRef} onMenuToggle={handleMenuToggle} isSidebarOpen={isSidebarOpen} />
      <div className="layout-body">
        <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        <div className="layout-content">
          <main className="layout-main">
            {title && (
              <div className="layout-page-header">
                <h1 className="layout-title">{title}</h1>
              </div>
            )}
            <div className="layout-page-content">
              {children}
            </div>
          </main>
        </div>
      </div>

      <PoweredBy />
    </div>
  );
};

export default Layout;
